import type { ComponentType } from "react";
import { MissionIcon } from "./MissionIcon";
import { PlatformsIcon } from "./PlatformsIcon";
import { CapabilitiesIcon } from "./CapabilitiesIcon";
import { InsightsIcon } from "./InsightsIcon";
import { NewsIcon } from "./NewsIcon";

export type NavSvgIconProps = {
  size?: number;
  className?: string;
  play?: boolean;
};

export const NAV_SVG_ICONS: Record<string, ComponentType<NavSvgIconProps>> = {
  mission: MissionIcon,
  platforms: PlatformsIcon,
  capabilities: CapabilitiesIcon,
  insights: InsightsIcon,
  news: NewsIcon,
  press: NewsIcon,
};

export { MissionIcon, PlatformsIcon, CapabilitiesIcon, InsightsIcon, NewsIcon };
